<template>
	<UiModalMobile
		v-model="modelValue"
		class="modal__mobile"
		:titleBtnSave="'Сохранить'"
		:isDontNeedCloseWhenSave="false"
		@save="saveHandler"
		height="calc(100% - 145px)"
		min-height-body="unset"
		:is-loading-btn-save="props.isLoading"
		:is-need-cancel-btn="false"
		:isNeedBtnSave="false"
		:isNeedFixedModalWithIfElseBlock="false"
		:z-index="10000"
	>
		<TypographyKTypographyBody2
			color="var(--color_font_black_wite)"
			font-type="bold"
			class="header__title"
		>
			{{ getTitle }}
		</TypographyKTypographyBody2>
		<CommonInputSpecialInput
			v-model="payload.searchInput"
			:readonly="false"
			:isNeedChangeBtn="true"
			:isNeedAlwaysVisibleInput="true"
			btnTitle="Найти"
			placeholder="Поиск"
			@clickBtn="searchSender"
			class="content-wrapper"
			:isLoading="loading.searchSender"
		>
			<template #left-icon>
				<UiIcon
					name="search"
					width="20px"
					@click="searchSender"
				/>
			</template>
			<template #additional-content>
				<div class="content">
					<DynamicScroller
						class="scroller"
						:items="clientsList"
						:min-item-size="80"
						key-field="id"
					>
						<template v-slot="{ item: client, index, active }">
							<DynamicScrollerItem
								:item="client"
								:active="active"
								:size-dependencies="[client.name, client.inn]"
								:data-index="index"
							>
								<div
									class="client"
									:class="{ '--active': client.id === getCurrentClient?.id }"
								>
									<div class="client__card">
										<TypographyKTypographyBody4
											class="title"
											font-type="semi-bold"
										>
											{{ client?.name }}
										</TypographyKTypographyBody4>

										<div class="client__body">
											<div class="text-block">
												<TypographyKTypographyBody5 class="title">ИНН/БИН:</TypographyKTypographyBody5>
												<TypographyKTypographyBody5 class="subtitle">{{ client?.inn }}</TypographyKTypographyBody5>
											</div>
										</div>

										<UiButton
											:size="ButtonSizeType.small"
											:color="ButtonType.primary"
											label="Выбрать"
											class="choose-btn"
											@click="chooseClient(client)"
										/>
									</div>
								</div>
							</DynamicScrollerItem>
						</template>
					</DynamicScroller>
				</div>
			</template>
		</CommonInputSpecialInput>
		<template #custom-actions>
			<div class="actions">
				<UiButton
					:label="typeClients === TClientType.Sender ? 'Создать отправителя' : 'Создать получателя'"
					:size="ButtonSizeType.small"
					:color="ButtonType.blue_light"
					class="btn"
					@click="addedClientHandler"
				/>
			</div>
		</template>
		<PagesStorekeeperAddedClient
			v-model="modals.addedNewClient"
			:typeClients="typeClients"
			v-if="modals.addedNewClient"
			:zIndex="3000"
			@save="saveNewClient"
		/>
	</UiModalMobile>
</template>

<script setup lang="ts">
	import { useStorekeeperStore } from '~/store/storekeeper.store';
	import { useStorekeeperClientsStore } from '~/store/storekeeperClients';
	import { TClientType, type IClient } from '~~/shared/interfaces/storekeeperClient';
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';

	const emits = defineEmits(['save', 'chooseClient']);
	const modelValue = defineModel('modelValue', { required: true, type: Boolean });
	const props = withDefaults(
		defineProps<{
			isLoading?: boolean;
			searchInputDefault?: string;
			currentCargo: any;
			typeClients: TClientType;
		}>(),
		{
			searchInputDefault: ''
		}
	);

	const storekeeperStore = useStorekeeperStore();
	const storekeeperClientStore = useStorekeeperClientsStore();
	const clientsList = ref<IClient[]>([]);

	const getTitle = computed(() => {
		if (props.typeClients === TClientType.Sender) {
			return 'Найти отправителя';
		} else if (props.typeClients === TClientType.Recipient) {
			return 'Найти получателя';
		}
		return 'Поиск';
	});

	const getCurrentClient = computed(() => {
		if (props.typeClients === TClientType.Sender) {
			return props.currentCargo?.clientSender;
		} else if (props.typeClients === TClientType.Recipient) {
			return props.currentCargo?.clientRecipient;
		}
		return props.currentCargo?.clientPayeer;
	});

	const modals = reactive({
		addedNewClient: false
	});
	const loading = reactive({
		searchSender: false,
		saveNewClient: false
	});
	const payload = ref({
		searchInput: props.searchInputDefault
	});

	const addedClientHandler = () => {
		modals.addedNewClient = true;
	};

	const chooseClient = async (client: IClient) => {
		console.log(client);
		emits('chooseClient', client, props.typeClients);

		modelValue.value = false;
	};

	const searchSender = async () => {
		loading.searchSender = true;
		const response = await storekeeperClientStore.getStorekeeperClients({ searchText: payload.value.searchInput });

		if (response.status === 'success') {
			clientsList.value = response.data || [];
		}

		loading.searchSender = false;
	};

	const saveNewClient = async (payload: { id?: string; name: string }) => {
		loading.saveNewClient = true;
		let virtualCargoCreateResponse;
		if (!props.currentCargo?.id) {
			virtualCargoCreateResponse = await storekeeperStore.virtualCargoSave({});
			storekeeperStore.currentCargo = { ...storekeeperStore.currentCargo, id: virtualCargoCreateResponse.data?.id };
		}
		const response = await storekeeperClientStore.createOrAttachStorekeeperClient({
			query: {
				clientType: props.typeClients,
				virtualCargoId: props.currentCargo?.id || virtualCargoCreateResponse?.data?.id
			},
			body: { name: payload.name }
		});
		if (response.status === 'success') {
			const submitPaylod =
				props.typeClients === TClientType.Sender ? response.data?.clientSender : response.data?.clientRecipient;
			modals.addedNewClient = false;
			modelValue.value = false;
			emits('chooseClient', submitPaylod, props.typeClients);
		}
		loading.saveNewClient = false;
	};

	const saveHandler = async (status: string) => {};
</script>

<style scoped lang="scss">
	.header__title {
		margin-bottom: 6px;
	}

	.content-wrapper {
		display: flex;
		flex-direction: column;
		height: calc(100% - 30px) !important;
	}
	.content {
		display: flex;
		overflow: auto;
		margin-top: 1rem;
		height: calc(100% - 100px);
		margin-right: -5px;
		padding-right: 5px;

		.scroller {
			display: flex;
			flex-direction: column;
			gap: 8px;
			height: calc(100%);
			width: 100%;
			margin-right: -5px;
			padding-right: 5px;
		}

		.scroller :deep(.vue-recycle-scroller__item-view) {
			will-change: transform;
		}

		.client {
			padding-bottom: 8px;

			&__card {
				background-color: var(--white);
				border-radius: 12px;
				padding: 12px 12px;
			}

			&.--active {
				.client__card {
					border: 1px solid var(--red);
				}
			}

			.client__body {
				background-color: #eaedf5;
				padding: 10px;
				border-radius: 10px;
				margin-top: 6px;

				.text-block {
					display: flex;
					flex-direction: column;
					gap: 3px;

					.title {
						font-weight: 600;
					}

					.subtitle {
					}
				}
			}

			.choose-btn {
				margin-top: 8px;
				width: 100%;
			}
		}
	}

	.actions {
		.btn {
			width: 100%;
		}
	}
</style>
